import * as React from "react";

const AnalyticsIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M5 19V10"
      stroke={props.color || "black"}
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M12 19V5"
      stroke={props.color || "black"}
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M19 19V13"
      stroke={props.color || "black"}
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export default AnalyticsIcon;